{
  "#MDE_BESTELLERFASSUNG": {
    "STEPS": {
      "LIEFERANT": {
        "TITLE": "Lieferant",
        "DESCRIPTION": "Bitte Lieferant auswählen!"
      },
      "LIEFERTERMIN": {
        "TITLE": "Liefertermin",
        "DESCRIPTION": "Bitte Liefertermin eingeben!"
      },
      "LAGER": {
        "TITLE": "Lager",
        "DESCRIPTION": "Bitte Lagerplatz auswählen!"
      }
    }
  }
}
